<template>
  <div class="login-page">
    <div class="page-top">
      <!-- 导航 -->
      <Header :LogoSrc="LogoSrc"></Header>
    </div>
    <div class="clearFix login-content">
      <div class="floatl login-content-left">
        <img class src="~@img/stk-logo-white.png" alt="Logo">
        <div>公司致力于各种耗材、试剂、仪器的销售推广及对市场的研究与服务工作。公司的经营理念“品质、服务、激情、开拓”，满足客户的需求，为客户创造价值使我们唯一的宗旨。</div>
      </div>
      <div class="floatr login-content-right">
        <div>登录</div>
        <div>输入您的账号密码。若没有账号密码，请您点 击下方注册</div>
        <div class="login-input-box white-placeholder-box">
          <el-input v-model="loginVal" placeholder="邮箱/手机号" clearable></el-input>
          <el-input v-model="password" type="password" placeholder="密码" clearable></el-input>
        </div>
        <div class="login-button-box clearFix">
          <el-button class="floatl" @click="login">登录</el-button>
          <el-button class="floatr" @click="register">注册</el-button>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="DIV">
        <img class="footer-logo" src="~@img/stk-logo-white.png" alt="Logo">
        <div>
          <a class="name">EXPERTISE OUTSTANDING SERVICE</a>
          <br>
          <a>北京赛泰克生物科技有限公司</a>
        </div>
      </div>
      <div class="footer-center-box">
        <div>{{this.stkAboutusInfo.aboutusName}}</div>
        <div>电话：{{this.stkAboutusInfo.phoneNumberName}} 传真分机：{{this.stkAboutusInfo.faxName}}</div>
      </div>
      <div class="footer-bottom-box">COPYRIGHT ©️ 北京赛泰克生物科技有限公司 2007-2018, 版权所有 京ICP备14006254号-1</div>
    </div>
  </div>
</template>

<script>
var qs = require("qs");
import { post, get } from "@/axios/index";
import Header from "@commonControl/header";

export default {
  data() {
    return {
      //头部logo
      LogoSrc: "http://static.cakeboss.com.cn/stkWhiteFontLogo1.png",
      loginVal: "",
      password: "",
      stkAboutusInfo: {
        //地址
        aboutusId: "",
        aboutusName: "",
        //电话
        phoneNumberId: "",
        phoneNumberName: "",
        //传真
        faxId: "",
        faxName: ""
      }
    };
  },
  components: {
    Header
  },
  methods: {
    //登录
    login() {
      const phoneReg = /^[1][3|4|5|7|8][0-9]{9}$/;
      const mailReg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      const loginVal = this.loginVal;
      const password = this.password;
      if (!loginVal) {
        this.$message({
          type: "warning",
          message: "请输入邮箱或手机号！"
        });
        return;
      }
      if (!password) {
        this.$message({
          type: "warning",
          message: "请输入密码！"
        });
        return;
      }
      if (phoneReg.test(loginVal) || mailReg.test(loginVal)) {
        const data = qs.stringify({
          loginVal: this.loginVal.toString(),
          password: this.password.toString()
        });
        console.log("登录");
        post("/stkuserregisterinfo/login", {
          emailAndphone: this.loginVal.toString(),
          password: this.password.toString()
        }).then(
          response => {
            console.log(response.data.result);
            console.log(response.data);
            if (response.data.code == 201) {
              return this.$message({
                type: "error",
                message: response.data.msg
              });
            }
            var oDate = new Date();
            oDate.setDate(oDate.getDate() + 7);
            document.cookie =
              "stkMessage=" +
              JSON.stringify(response.data.result) +
              ";expires=" +
              oDate.toGMTString();
            sessionStorage.setItem(
              "stkMessage",
              JSON.stringify(response.data.result)
            );
            localStorage.setItem(
              "stkMessage",
              JSON.stringify(response.data.result)
            );
            this.$router.push("/pc/product");
            // }
          },
          err => {
            console.log(err);
          }
        );
      } else {
        this.$message({
          type: "warning",
          message: "邮箱或手机号格式不正确！"
        });
        return;
      }
    },
    //注册
    register() {
      this.$router.push("/pc/register");
    },
    gatListByStatus() {
      get("/stkaboutus/gatListByStatus", {}).then(
        ren => {
          console.log("150=======", ren.data.result);
          let res = ren.data.result;
          for (let i in res) {
            console.log("108=======", res[i]);
            if (res[i].contact === "地址") {
              this.stkAboutusInfo.aboutusId = res[i].id;
              this.stkAboutusInfo.aboutusName = res[i].name;
            }
            if (res[i].contact === "电话") {
              this.stkAboutusInfo.phoneNumberId = res[i].id;
              this.stkAboutusInfo.phoneNumberName = res[i].name;
            }
            if (res[i].contact === "传真") {
              this.stkAboutusInfo.faxId = res[i].id;
              this.stkAboutusInfo.faxName = res[i].name;
            }
          }
          console.log("166=======", this.stkAboutusInfo);
        },
        err => {
          console.log(err);
          this.$message({
            type: "error",
            message: "error"
          });
        }
      );
    }
  },
  mounted() {
    //获取详情
    this.gatListByStatus();
  }
};
</script>


<style scoped lang="less">
/deep/.page-top {
  background: transparent;
  position: relative;
  .common-content-width();
}

/deep/.header-r-box {
  display: none;
}

.login-page {
  background: url("~@img/stk-login-bg.png") no-repeat center center;
  background-size: cover;
  width: 100%;
}

.header-logo {
  width: 109px;
  margin-right: 27px;
}

.header-l-box {
  color: #fff;
  font-size: 12px;
  line-height: 22px;
}

.header-l-box > div:last-child {
  position: relative;
  top: 8px;
}

.page-top /deep/ .nav-box {
  background: transparent !important;
}

.login-content-right {
  color: #fff;
  width: 369px;
  height: 441px;
  background-image: linear-gradient(
    -4deg,
    rgba(31, 155, 255, 0.3) 0%,
    rgba(0, 93, 168, 0.3) 100%
  );
  padding: 27px 38px;
  margin-top: 30px;
  > div {
    margin-bottom: 36px;
    font-size: 14px;
  }
  > div:first-child {
    text-align: center;
    font-size: 20px;
    letter-spacing: 1px;
  }
  > div:nth-of-type(2) {
    line-height: 24px;
  }
}

/deep/.login-input-box .el-input {
  height: 40px;
  line-height: 40px;
  background-color: #91b2e4 !important;
  border-radius: 8px;
  padding: 0;
  margin-bottom: 15px !important;
  .el-input__inner {
    background-color: transparent !important;
    border: 0;
    padding: 0 24px;
    color: #fff;
  }
}

.login-content {
  .common-content-width();
  color: @common-blue;
}

/deep/.login-content-left {
  color: #fff;
  width: 368px;
  line-height: 26px;
  div {
    font-size: 16px;
  }
  > img {
    display: block;
    width: 297px;
    margin: 110px auto 80px;
  }
}

.login-button-box .el-button {
  width: 121px;
  height: 40px;
  background-color: #5879ab;
  border-radius: 8px;
  color: #fff;
  border: 0;
}

.footer {
  margin-top: 11%;
  background: #16325b;
}

/deep/ .head-select > .el-input__inner {
  height: 30px;
}

/deep/ .el-button:hover {
  color: #333;
  background-color: rgba(0, 0, 0, 0);
}

/deep/ .el-button:focus {
  color: #333;
  background-color: rgba(0, 0, 0, 0);
}

/deep/.el-button:focus,
.el-button:hover {
  color: #fff !important;
  background-color: #6b8bbc !important;
}
.footer-logo {
  width: 90px;
  /* margin-bottom: 20px; */
}
.DIV {
  display: flex;
  justify-content: center;
  align-items: center;
}
.name {
  position: relative;
  left: 13%;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/login/Login.vue